export default "__VITE_ASSET__OJsoGiEG__"